// test1981
(1981 && 0);
